export const SvgLock = ({ color }: any) => {
	return (
		<svg
			width="18"
			height="20"
			viewBox="0 0 18 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.0331 18.5H3.96736C2.7371 18.5 1.73047 17.4933 1.73047 16.2631L1.73064 8.43416C1.73064 7.2039 2.73727 6.19727 3.96753 6.19727H14.0333C15.2636 6.19727 16.2702 7.2039 16.2702 8.43416V16.2631C16.27 17.4933 15.2636 18.5 14.0333 18.5H14.0331Z"
				stroke={color ? color : "#666666"}
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.0346 6.19741C13.8669 3.56919 11.686 1.5 9.00169 1.5C6.31754 1.5 4.19255 3.56902 3.96875 6.19741"
				stroke={color ? color : "#666666"}
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.00119 14.5865C8.38604 14.5865 7.88281 14.0832 7.88281 13.4681V11.2312C7.88281 10.616 8.38604 10.1128 9.00119 10.1128C9.61633 10.1128 10.1196 10.616 10.1196 11.2312V13.4681C10.1196 14.0832 9.61633 14.5865 9.00119 14.5865Z"
				fill={color ? color : "#666666"}
			/>
		</svg>
	);
};
